var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "v-expansion-panels",
        { attrs: { disabled: _vm.disabled } },
        [
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [
                _vm._v(" Анкеты (" + _vm._s(_vm.getProfileCount) + ")"),
              ]),
              _vm._l(_vm.profilesList, function (profile) {
                return _c(
                  "v-expansion-panel-content",
                  { key: profile.id + profile.profileType },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: _vm.getProfileLink(profile) } },
                      [_vm._v(_vm._s(_vm.getProfileName(profile)))]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [
                _vm._v(
                  " Полученный общий доступ (" +
                    _vm._s(_vm.getSharedAccessCount) +
                    ") "
                ),
              ]),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-expansion-panels",
                    _vm._l(_vm.getSharedAccessTitle, function (el, idx) {
                      return _c(
                        "v-expansion-panel",
                        { key: idx + el.title },
                        [
                          _vm.getSharedContentLength(el)
                            ? [
                                _c("v-expansion-panel-header", [
                                  _vm._v(
                                    _vm._s(el.title) +
                                      "(" +
                                      _vm._s(_vm.getSharedContentLength(el)) +
                                      ")"
                                  ),
                                ]),
                                _c(
                                  "v-expansion-panel-content",
                                  [
                                    _c(
                                      "v-list",
                                      _vm._l(el.content, function (item) {
                                        return _c(
                                          "v-list-item",
                                          { key: item.id },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to: _vm.getLinkEntity(item),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getContentTitle(item)
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [
                _vm._v(
                  " Мои резервации (" + _vm._s(_vm.getReservationsCount) + ") "
                ),
              ]),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-expansion-panels",
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", [
                            _vm._v(
                              "Резервации событий (" +
                                _vm._s(_vm.getTicketReservations) +
                                ")"
                            ),
                          ]),
                          _vm.getTicketReservations > 0
                            ? _c(
                                "v-expansion-panel-content",
                                [
                                  _c(
                                    "v-list",
                                    _vm._l(
                                      _vm.getKeysTicketReservations,
                                      function (ticketReservation, idx) {
                                        return _c("v-list-item", { key: idx }, [
                                          _c(
                                            "span",
                                            [
                                              _vm._v(
                                                _vm._s(ticketReservation) + ": "
                                              ),
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "page-orders-event",
                                                      query: {
                                                        id: _vm.ticketReservations.list.find(
                                                          (ticket) =>
                                                            ticket.displayName ===
                                                            ticketReservation
                                                        ).id,
                                                      },
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .preparedTicketReservations[
                                                        ticketReservation
                                                      ]
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", [
                            _vm._v(
                              "Резервации отелей (" +
                                _vm._s(_vm.getHotelReservationsCount) +
                                ")"
                            ),
                          ]),
                          _vm.getHotelReservationsCount > 0
                            ? _c(
                                "v-expansion-panel-content",
                                [
                                  _c(
                                    "v-list",
                                    _vm._l(
                                      _vm.getKeysHotelReservations,
                                      function (hotelReservation, idx) {
                                        return _c("v-list-item", { key: idx }, [
                                          _c(
                                            "span",
                                            [
                                              _vm._v(
                                                _vm._s(hotelReservation) + ": "
                                              ),
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "page-orders-booking",
                                                      query: {
                                                        id: _vm.findIdForLink(
                                                          hotelReservation
                                                        ),
                                                      },
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .preparedHotelReservations[
                                                        hotelReservation
                                                      ]
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ])
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }